import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { API_STATUS } from "../../constants";
import { SendApproachApi } from "../../apis/user/send_approach_api";
import { ApprochNote } from "../../apis/notification/approach_note";

export default function Approach({ userId, setAppTab }) {
    const [sendApi, setSendApi] = useState(API_STATUS);

    const SignupSchema = Yup.object().shape({
        regards: Yup.string()
            .min(10, 'Too Short!')
            .required('Enter reqards'),
        requirement: Yup.string()
            .min(10, 'Too Short!')
            .required('Enter requirement')
    });

    useEffect(() => {
        if (!sendApi.isError && !sendApi.isLoader && sendApi.data != null) {
            if (sendApi.data.status === 1) {
                ApprochNote(sendApi.data.data);
                setAppTab(false);
            }
        }
    }, [sendApi]);

    return <div>
        <div style={{ textAlign: "center", padding: 15 }}>
            <span className="title" style={{ fontWeight: 'bold' }}>Submit your requirements</span>
        </div>

        <div className="bg-white p-5 md:max-w-[510px] mx-auto border rounded-xl shadow-sm">

            <Formik
                enableReinitialize={true}
                initialValues={{
                    followId: userId,
                    regards: "",
                    requirement: "",
                    details: ""
                }}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    let body = values;
                    SendApproachApi(body, setSendApi);
                }}
            >
                {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                    <div className="space-y-6">

                        <div className="md:flex items-start gap-10">
                            <label className="md:w-32 text-right"> Reagards </label>
                            <div className="flex-1 max-md:mt-4">
                                <Field as="textarea" name="regards" className="w-full" rows="2" placeholder=""></Field>
                            </div>
                        </div>
                        {
                            errors.regards && touched.regards &&
                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.regards}</div>
                        }

                        <div className="md:flex items-start gap-10">
                            <label className="md:w-32 text-right"> Requirements </label>
                            <div className="flex-1 max-md:mt-4">
                                <Field as="textarea" name="requirement" className="w-full" rows="2" placeholder=""></Field>
                            </div>
                        </div>
                        {
                            errors.requirement && touched.requirement &&
                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.requirement}</div>
                        }

                        <div className="md:flex items-start gap-10">
                            <label className="md:w-32 text-right"> Description </label>
                            <div className="flex-1 max-md:mt-4">
                                <Field as="textarea" name="details" className="w-full" rows="2" placeholder=""></Field>
                            </div>
                        </div>

                        <div class="flex items-center justify-center gap-4 mt-16">
                            <button onClick={() => {
                                setAppTab(false);
                            }} className="button bg-pink-100 text-pink-600 border border-pink-200">Cancel</button>
                            <button onClick={() => {
                                if (!isValid) {
                                    setFieldTouched('regards');
                                    setFieldTouched('requirement');
                                } else {
                                    handleSubmit();
                                }
                            }} type="button" class="button lg:px-10 bg-primary text-white max-md:flex-1"> Submit <span class="ripple-overlay"></span></button>
                        </div>

                    </div>
                )}
            </Formik>
        </div>
    </div>
}